import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AdminApp from "./AdminApp";
import ReviewerApp from "./ReviewerApp";
import PhotoLibraryApp from "./PhotoLibraryApp";
import ServiceAvailabilityGate from "./ServiceAvailabilityGate";
import { livePreviewEnabled } from "./auth";
import "./app.css";
import "./auth.css";
import "./workflow.css";
import "./workflow-dashboard.css";
import "./admin-workspace.css";
import "./central-ccd.css";
import "./portrait-guide.css";
import "./portrait-guide-right-rail-fix.css";
import "./studio-refine-redesign.css";
import "./request-history-actions.css";
import "./service-availability.css";
import "./brand-logo.css";

const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();
const buAvailabilityEnabled = import.meta.env.VITE_BU_SERVICE_AVAILABILITY_ENABLED === "true";
const root = path === "/photo-library"
  ? <PhotoLibraryApp />
  : path === "/admin"
  ? <AdminApp />
  : path === "/reviewer"
    ? <ReviewerApp />
    : path === "/direct-update"
      ? <App directUpdateMode />
      : buAvailabilityEnabled
        ? <ServiceAvailabilityGate><App /></ServiceAvailabilityGate>
        : <App />;

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {livePreviewEnabled && <div className="workflow-notice" role="status"><strong>Preview — live Production data.</strong> Changes made here affect real requests, settings and Microsoft 365 according to your permissions. Reviewer Portal is read-only.</div>}
    {root}
  </React.StrictMode>,
);
